// extracted by mini-css-extract-plugin
export default {"component":"ShutdownButton_component__n1cyq","component_disabled":"ShutdownButton_component_disabled__JNPuk","icon":"ShutdownButton_icon__lbTD+","text":"ShutdownButton_text__5vLEO"};